// import { isLoggedInGuardV2, makeLoginGuard } from "../../router/guards";
import { makeLoginGuard } from "../../router/guards";
// import { LAUNCH_ROUTES_PATHS } from "@/launch/launch-routes";

export const LAUNCH_ROUTES_PATHS_V2_DIR = "v2";
export const LAUNCH_ROUTES_PATHS_V2_BASE = "#/" + LAUNCH_ROUTES_PATHS_V2_DIR;

export const LAUNCH_ROUTES_PATHS_V2 = {
  HOME_V2: "home-v2",
  LOGIN_V2: "login-v2",
  REGISTER_V2: "register-v2",
  FORGOT_V2: "forgot-v2",
  RESET_V2: "reset_pwd", //  N.B. the underscore, not a dash.
  ENTRY_V2: "entry-v2",
  SHOW_ENTRY_v2: "show-entry-v2",
  ATHLETE_V2: "athlete-v2",
  ATHLETES_V2: "athletes-v2",
  SHOP_V2: "shop-v2",
  SCHED_COMP_PUBLIC: "schedule-v2",
  MESSAGES_V2: "messages-v2",
  USER_SEARCH_V2: "user-search-v2",
  USER_V2: "user-v2",
  CLUB_SEARCH_V2: "club-search-v2",
  CLUB_V2: "club-v2",

  BUILDER_V2: "builder-v2",
  CONTACT_ORGANISER_V2: "contact-organiser-v2",
  RESULTS_IMPORT_FILE: "results-import-file",
  RESULTS_MANUAL: "results-v2",
  RESULTS_ENTRY: "results-entry-v2",
  CHECK_IN_V2: "checkin-v2",
  TICKET_ADMIN_V2: "ticket-admin-v2",
  TICKET_FORM_GATEKEEPER: "ticket-form-gatekeeper",

  SCOREBOARD_OUTPUT_LIST: "scoreboard-output-list",
  SCOREBOARD_SCHEDULE_LIST: "scoreboard-schedule-list",
  BIBS_V2: "bibs-v2",

  FORM_GENERIC_EXAMPLE_V2: "form-generic-example-v2",
};
// Bind a guard instance here to avoid circular imports with index.ts
const isLoggedInGuardV2 = makeLoginGuard(LAUNCH_ROUTES_PATHS_V2.LOGIN_V2);

type LaunchRoutesV2 = typeof LAUNCH_ROUTES_PATHS_V2;
export type LaunchRouteKeyV2 = keyof LaunchRoutesV2;
export type LaunchRouteValueV2 = LaunchRoutesV2[keyof LaunchRoutesV2];

export const launchRoutesV2: any = [
  {
    name: LAUNCH_ROUTES_PATHS_V2.HOME_V2,
    path: "",
    component: () => {
      return import("../../public/entry-public/v2/entry-public-v2.vue");
    },
    meta: {
      title: "Home",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.HOME_V2,
    path: LAUNCH_ROUTES_PATHS_V2.HOME_V2,
    component: () => {
      return import("../../public/entry-public/v2/entry-public-v2.vue");
    },
    meta: {
      title: "Home",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.LOGIN_V2,
    path: LAUNCH_ROUTES_PATHS_V2.LOGIN_V2,
    component: () => {
      return import("../../auth/v2/login-container-v2.vue");
    },
    meta: {
      title: "Login",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.REGISTER_V2,
    path: LAUNCH_ROUTES_PATHS_V2.REGISTER_V2,
    component: () => {
      return import("../../auth/v2/register/register-container-v2.vue");
    },
    meta: {
      title: "Register",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.RESET_V2,
    path: LAUNCH_ROUTES_PATHS_V2.RESET_V2,
    component: () => {
      return import("../../auth/v2/reset/reset-container-v2.vue");
    },
    meta: {
      title: "Reset",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.FORGOT_V2,
    path: LAUNCH_ROUTES_PATHS_V2.FORGOT_V2,
    component: () => {
      return import("../../auth/v2/forgot/forgot-container-v2.vue");
    },
    meta: {
      title: "Forgot",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.ENTRY_V2,
    path: LAUNCH_ROUTES_PATHS_V2.ENTRY_V2 + "/:id",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../entry/v2/entry-route-v2.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Entry";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.SHOW_ENTRY_v2,
    path: LAUNCH_ROUTES_PATHS_V2.SHOW_ENTRY_v2 + "/:id",
    component: () => {
      return import("../../public/entry-public/v2/entry-direct-v2.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Comp";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.ATHLETE_V2,
    path: LAUNCH_ROUTES_PATHS_V2.ATHLETE_V2 + "/:id",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../athlete/v2/form/athlete-form-route-v2.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Athlete";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.ATHLETES_V2,
    path: LAUNCH_ROUTES_PATHS_V2.ATHLETES_V2,
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../athlete/v2/search/athlete-search-route-v2.vue");
    },
    meta: {
      title: "Athletes",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.SCHED_COMP_PUBLIC,
    path: LAUNCH_ROUTES_PATHS_V2.SCHED_COMP_PUBLIC + "/:id",
    component: () => {
      return import(
        "../../competition/results/public/schedule/v2/schedule-comp-public-route-v2.vue"
      );
    },
    meta: {
      title: "Schedule",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.MESSAGES_V2,
    path: LAUNCH_ROUTES_PATHS_V2.MESSAGES_V2 + "/:compId?",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import(
        "../../email-message/grid/v2/email-message-grid-route-v2.vue"
      );
    },
    meta: {
      title: (params: { compId: number }) => {
        return (
          "Messages" +
          (params.compId && params.compId > 0
            ? " for Comp: " + params.compId
            : "")
        );
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.USER_SEARCH_V2,
    path: LAUNCH_ROUTES_PATHS_V2.USER_SEARCH_V2,
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../admin/user/v2/user-search-v2.vue");
    },
    meta: {
      title: () => {
        return "Users";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.USER_V2,
    path: LAUNCH_ROUTES_PATHS_V2.USER_V2 + "/:id?",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../admin/user/v2/user-route-container-v2.vue");
    },
    meta: {
      title: () => {
        return "User";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.BUILDER_V2,
    path: LAUNCH_ROUTES_PATHS_V2.BUILDER_V2 + "/:id",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../builder/form/builder-form.vue");
    },
    meta: {
      title: (params: { id: number }) => {
        return params.id + ": Builder";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.FORM_GENERIC_EXAMPLE_V2,
    path: LAUNCH_ROUTES_PATHS_V2.FORM_GENERIC_EXAMPLE_V2,
    component: () => {
      return import("../../common/ui/layoutV2/form/form-generic-example.vue");
    },
    meta: {
      title: () => {
        return "Example Form";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.CONTACT_ORGANISER_V2,
    path: LAUNCH_ROUTES_PATHS_V2.CONTACT_ORGANISER_V2 + "/:id",
    component: () =>
      import("../../competition/askorganiser/AskOrganiserRoute.vue"),
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Contact";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.CLUB_SEARCH_V2,
    path: LAUNCH_ROUTES_PATHS_V2.CLUB_SEARCH_V2,
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../club/v2/club-search.vue");
    },
    meta: {
      title: () => {
        return "Clubs";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.CLUB_V2,
    path: LAUNCH_ROUTES_PATHS_V2.CLUB_V2 + "/:id",
    component: () => {
      return import("../../club/v2/club-route.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Club";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.SHOP_V2,
    path: LAUNCH_ROUTES_PATHS_V2.SHOP_V2 + "/:id",
    component: () => {
      return import("../../secondary/v2/secondary-public-v2.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Shop";
      },
    },
  },
  {
    name: "shop-v3",
    path: "shop-v3/:id",
    component: () => {
      return import("../../secondary/v3/shop-route-v3.vue");
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Shop V3";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.CHECK_IN_V2,
    path: LAUNCH_ROUTES_PATHS_V2.CHECK_IN_V2 + "/:id",
    component: () => {
      return import(
        "../../competition/checkin/checkin-organiser/checkin-organiser.vue"
      );
    },
    meta: {
      title: (params: { id: string }) => {
        return params.id + ": Check In";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.TICKET_ADMIN_V2,
    path: LAUNCH_ROUTES_PATHS_V2.TICKET_ADMIN_V2 + "/:compId",
    component: () => {
      return import(
        "../../secondary/ticket/ticket-admin/ticket-admin-route.vue"
      );
    },
    meta: {
      title: (params: { compId: string }) => {
        return params.compId + ": Ticket Admin";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.TICKET_FORM_GATEKEEPER,
    path: LAUNCH_ROUTES_PATHS_V2.TICKET_FORM_GATEKEEPER + "/:compId",
    component: () => {
      return import(
        "../../secondary/ticket/ticket-gatekeeper/ticket-route-gatekeeper.vue"
      );
    },
    meta: {
      title: (params: { compId: string }) => {
        return params.compId + ": Ticket Admin";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.RESULTS_MANUAL,
    path: LAUNCH_ROUTES_PATHS_V2.RESULTS_MANUAL + "/:compId",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import(
        "../../competition/results/public/schedule/results-public-route.vue"
      );
    },
    meta: {
      title: "Results",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.RESULTS_ENTRY,
    path: LAUNCH_ROUTES_PATHS_V2.RESULTS_ENTRY + "/:compId/:eventGroupId",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../competition/results/result-route.vue");
    },
    meta: {
      title: "Results Entry",
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.RESULTS_IMPORT_FILE,
    path: LAUNCH_ROUTES_PATHS_V2.RESULTS_IMPORT_FILE + "/:id",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import(
        "../../competition/results/results-file-import/ResultsImportFileRoute.vue"
      );
    },
    meta: {
      title: () => {
        return "Photo Finish";
      },
    },
  },
  {
    name: LAUNCH_ROUTES_PATHS_V2.SCOREBOARD_OUTPUT_LIST,
    path: LAUNCH_ROUTES_PATHS_V2.SCOREBOARD_OUTPUT_LIST + "/:compId",
    component: () => {
      // ../competition/scoreboard/scoreboard-schedule/scoreboard-schedule-list/scoreboard-schedule-list-route.vue
      return import(
        "../../competition/scoreboard/scoreboard-output/list/scoreboard-output-list-route.vue"
      );
    },
    meta: {
      title: (params: { compId: string; outputId: string }) => {
        return params.compId + "/" + params.outputId + ": Scoreboard Sched";
      },
    },
  },
  //  bibs
  {
    name: LAUNCH_ROUTES_PATHS_V2.BIBS_V2,
    path: LAUNCH_ROUTES_PATHS_V2.BIBS_V2 + "/:id",
    beforeEnter: isLoggedInGuardV2,
    component: () => {
      return import("../../competition/admin/bibs/bib-form-route.vue");
    },
    meta: {
      title: (params: { compId: string }) => {
        return params.compId + ": Bibs";
      },
    },
  },
];

export const widerRoutesClass: Record<LaunchRouteValueV2, string> = {
  "home-v2": "e4s-width-controller-entry",
  "builder-v2": "e4s-width-controller--builder",
};

// "../competition/results/results-file-import/ResultsImportFileRoute.vue"
